import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import forOwn from 'lodash/forOwn'
import { Button } from 'reactstrap'

import withAuthorization from '../higherOrder/withAuthorization'

import { INTRO_QUESTIONS } from '../../constants/routes'
import { updateUserInFirebase, updateUserProfile, getUserProfile, setIntroQuestionsState } from '../../actions'
import countries from '../utilities/helper/Country'
import { numberToGardenKnowldge, gardenKnowldgeToNumber } from '../utilities/helpers'
import { ThreeBounceSpinner } from '../Global/LoadingSpinner'
import { LoadingWrapper } from '../StyledComponents/Classifier/LoadingScreen'
import { FillerDiv, CenteredDivWithMargin } from '../StyledComponents/Fillers'
import { InputText, CountrySelect, CountrySelectDropDown, CountrySelectDropDownItem, CountrySelectIcon, GardenKnowledgeIconWrapper, GardenKnowledgeIcon, GardenKnowledgeIconDescription } from '../StyledComponents/Pages/Intro'

const plantGray = require('../../assets/images/Intro/plant-gray.png')
const plantGreen = require('../../assets/images/Intro/plant-green.png')

class IntroPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showCountries: false,
            selectedCountry: 'DE',
            username: '',
            zipCode: '',
            knowledge: null,
        }

        this.optionClicked = this.optionClicked.bind(this)
        this.saveClicked = this.saveClicked.bind(this)
        this.usernameChanged = this.usernameChanged.bind(this)
        this.zipCodeChanged = this.zipCodeChanged.bind(this)
        this.knowledgeChanged = this.knowledgeChanged.bind(this)
    }

    componentDidMount() {
        const { sessionState, getProfile } = this.props

        if (!!sessionState && !!sessionState.idToken) {
            const { token } = sessionState.idToken
            getProfile(sessionState.authUser.uid, token)
        }
    }

    componentWillReceiveProps(newProps) {
        const { sessionState } = newProps
        const currentSession = this.props.sessionState

        if (!!sessionState && !!sessionState.authUser) {
            if (!!sessionState.username && !currentSession.username) {
                this.setState({ username: sessionState.username })
            }
            if (!!sessionState.zipCode && !currentSession.zipCode) {
                this.setState({ zipCode: sessionState.zipCode })
            }
            if (!!sessionState.country && !currentSession.country) {
                this.setState({ selectedCountry: sessionState.country })
            }
            if (!!sessionState.gardenKnowledge && !currentSession.gardenKnowledge) {
                this.setState({ knowledge: gardenKnowldgeToNumber(sessionState.gardenKnowledge) })
            }
        }
    }

    componentDidUpdate(prevProps) {
        const { sessionState, getProfile } = this.props

        if (!prevProps.sessionState.idToken && !!sessionState.idToken) {
            const { token } = sessionState.idToken
            getProfile(sessionState.authUser.uid, token)
        }
    }

    optionClicked(key) {
        this.setState({
            showCountries: false,
            selectedCountry: key,
        })
    }

    saveClicked(redirect) {
        const {
            sessionState, updateProfile, history, setIntroState,
        } = this.props
        const {
            selectedCountry, username, zipCode, knowledge,
        } = this.state

        if (!!sessionState && !!sessionState.authUser && !!sessionState.idToken) {
            const { token } = sessionState.idToken
            const { uid } = sessionState.authUser
            updateProfile(
                uid,
                token,
                username,
                selectedCountry,
                zipCode,
                numberToGardenKnowldge(knowledge)
            )

            if (redirect) {
                setIntroState(uid, token, 'intro')
                history.push(INTRO_QUESTIONS)
            }
        }
    }

    usernameChanged(e) {
        const { sessionState, updateFirebase } = this.props
        const newName = e.currentTarget.value

        this.setState({
            username: newName,
        })

        if (!!sessionState && !!sessionState.authUser) {
            updateFirebase(sessionState.authUser, newName)
        }
    }

    zipCodeChanged(e) {
        const newValue = e.currentTarget.value
            .replace(/\D/g, '')
            .substring(0, 5)

        this.setState({
            zipCode: newValue,
        })

        if (newValue.length === 5) {
            setTimeout(() => {
                // let state update before saving
                this.saveClicked(false)
            }, 300)
        }
    }

    knowledgeChanged(value) {
        this.setState({ knowledge: value })
    }

    render() {
        const {
            showCountries, selectedCountry, username, zipCode, knowledge,
        } = this.state

        const { sessionState } = this.props

        if (!sessionState || !sessionState.authUser || !sessionState.idToken) {
            return (
                <LoadingWrapper>
                    <ThreeBounceSpinner />
                </LoadingWrapper>
            )
        }

        const options = []
        forOwn(countries.countriesDE, (country, key) => {
            options.push((
                <CountrySelectDropDownItem onClick={() => this.optionClicked(key)}>
                    {country}
                </CountrySelectDropDownItem>
            ))
        })

        const dropdown = showCountries ? (
            <CountrySelectDropDown>
                {options}
            </CountrySelectDropDown>
        ) : null

        return (
            <FillerDiv>
                <CenteredDivWithMargin fontSize="1.4rem" top="10" left="20" right="20">
                    {'Dankeschön, dass du dich für unsere App angemeldet hast!'}
                    <br />
                    <br />
                    {'Erzähle uns doch ein bisschen was von dir:'}
                </CenteredDivWithMargin>
                <CenteredDivWithMargin top="30" left="10" right="10" bottom="30">
                    <InputText type="text" placeholder="Name" value={username} onChange={this.usernameChanged} />

                    <CenteredDivWithMargin fontSize="1.4rem" top="30" left="20" right="20">
                        {'Wie schätzt du deine Gartenkenntnisse ein?'}
                    </CenteredDivWithMargin>
                    <CenteredDivWithMargin fontSize="1.4rem" top="30" left="0" right="0" bottom="40">
                        <GardenKnowledgeIconWrapper onClick={() => this.knowledgeChanged(1)}>
                            <GardenKnowledgeIcon src={knowledge > 0 ? plantGreen : plantGray} />
                            <GardenKnowledgeIconDescription>
                                Anfänger
                            </GardenKnowledgeIconDescription>
                        </GardenKnowledgeIconWrapper>
                        <GardenKnowledgeIconWrapper onClick={() => this.knowledgeChanged(2)}>
                            <GardenKnowledgeIcon src={knowledge > 1 ? plantGreen : plantGray} />
                            <GardenKnowledgeIconDescription>
                                Hobby-Gärtner
                            </GardenKnowledgeIconDescription>
                        </GardenKnowledgeIconWrapper>
                        <GardenKnowledgeIconWrapper onClick={() => this.knowledgeChanged(3)}>
                            <GardenKnowledgeIcon src={knowledge > 2 ? plantGreen : plantGray} />
                            <GardenKnowledgeIconDescription>
                                Gartenexperte
                            </GardenKnowledgeIconDescription>
                        </GardenKnowledgeIconWrapper>
                    </CenteredDivWithMargin>

                    <CenteredDivWithMargin fontSize="1.4rem" top="30" left="20" right="20" bottom="10">
                        {'Wohnort:'}
                    </CenteredDivWithMargin>
                    <CountrySelect onClick={() => this.setState({ showCountries: !showCountries })}>
                        {countries.countriesDE[selectedCountry]}
                        <CountrySelectIcon isOpened={showCountries} name="sort-down" size="lg" />
                        {dropdown}
                    </CountrySelect>
                    <InputText type="text" placeholder="Postleitzahl" value={zipCode} onChange={this.zipCodeChanged} />
                    <CenteredDivWithMargin fontSize="0.8rem" left="20" right="20" bottom="30">
                        {'Der Ort wird verwendet, um Wettervorhersagen in die Berechnung der optimalen Bewässerungszeit mit einbeziehen zu können.'}
                    </CenteredDivWithMargin>
                    <Button color="info" onClick={() => this.saveClicked(true)}>Weiter</Button>
                </CenteredDivWithMargin>
            </FillerDiv>
        )
    }
}

const authCondition = authUser => !!authUser

const mapStateToProps = state => ({
    sessionState: state.sessionState,
})

export default compose(
    withAuthorization(authCondition),
    withRouter,
    connect(mapStateToProps, {
        updateFirebase: updateUserInFirebase,
        updateProfile: updateUserProfile,
        getProfile: getUserProfile,
        setIntroState: setIntroQuestionsState,
    })
)(IntroPage)



// WEBPACK FOOTER //
// ./src/components/pages/IntroPage.js